import request from "@/utils/request";
export const queryPage = "/icps/system/sign/basics/plan/query_product_page";
export const Download = "/icps/system/sign/intelligent/logisticsVote/receiveexportList";
/*生产排程-生产调整列表处理数据使用*/
export function query_product_page(data) {
  return request({
    url: "/icps/system/sign/basics/plan/query_product_page",
    method: "post",
    data,
  });
}

/*根据计划审核列表id获取用料计划列表*/
export function plan_list(params) {
  return request({
    url: "/icps/system/sign/basics/plan/plan_list",
    method: "get",
    params,
  });
}
/*根据计划审核列表id获取用料计划列表(带分页)*/
export function getPlanPage(data) {
  return request({
    url: "/icps/system/sign/basics/plan/getPlanPage",
    method: "post",
    data,
  });
}
/*根据计划审核列表id获取用料计划列表的头部信息*/
export function plan_table_detail(params) {
  return request({
    url: "/icps/system/sign/basics/plan/plan_table_detail",
    method: "get",
    params,
  });
}
/*添加订单*/
export function save_or_update(data) {
  return request({
    url: "/icps/system/sign/basics/plan/save_or_update",
    method: "post",
    data,
  });
}
/*获取强度等级和性能要求等。。。*/
export function getLists(data) {
  return request({
    url: "/icps/system/sign/basics/namingRule/getLists",
    method: "post",
    data,
  });
}
/*根据id获取详情信息*/
export function plan_detail(params) {
  return request({
    url: "/icps/system/sign/basics/plan/plan_detail",
    method: "get",
    params,
  });
}

// /*查询泵送，运输，泵管list*/
export function getContractVoList(params) {
  return request({
    url: "/icps/system/sign/dataCollection/contract/getContractVoList",
    method: "get",
    params,
  });
}

// /*根据计划id和工程id获取作业安排信息*/
export function operation_detail(params) {
  return request({
    url: "/icps/system/sign/basics/operation/operation_detail",
    method: "get",
    params,
  });
}
/*计划审核，同时支持修改订单信息和作业安排,同时修改审核状态*/
export function check_order(data) {
  return request({
    url: "/icps/system/sign/basics/plan/check_order",
    method: "post",
    data,
  });
}

/*物流明细表格数据获取*/
export function query_logistics_page(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/query_logistics_page",
    method: "post",
    data,
  });
}
/*物流明细数据详情获取*/
export function getLogisticsDetail(params) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/getLogisticsDetail",
    method: "get",
    params,
  });
}


/**
 * 生产调整保存接口，增加管控的判断
 * by rogerwei 210808
 * @param  {[type]} data [description]
 * @return {[type]}      [description]
 */
export function job_arrangement(data) {
  return request({
    url: "/icps/system/sign/basics/plan/job_arrangement",
    method: "post",
    data,
  });
}
/**/
export function approvalStatus(params) {
  return request({
    url: "/icps/system/sign/basics/plan/approval_status",
    method: "get",
    params,
  });
}
// 判断业务点是否被管控
export function judgePlanControl(params) {
  return request({
    url: "/icps/system/sign/basics/plan/judgePlanControl",
    method: "get",
    params
  });
}

/*工程名称列表：审核通过了的，*/
export function engineeringManagementQueryListFinish(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/queryListFinish",
    method: "post",
    data,
  });
}
/*工程履约的工程*/
export function engineeringManagementQueryPage(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/QueryPage",
    method: "post",
    data,
  });
}

// /*根据工程id获取风险管控信息*/
export function get_assess(params) {
  return request({
    url: "/icps/system/sign/basics/operation/get_assess",
    method: "get",
    params,
  });
}

/*调整生产数据：初始化表格数据*/
// export function init_data(params) {
//   return request({
//     url: "/icps/system/sign/basics/data/init_data",
//     method: "get",
//     params,
//   });
// }
// /*根据计划id获取调整的时间列表*/
// export function timeget_list(params) {
//   return request({
//     url: "/icps/system/sign/basics/time/get_list",
//     method: "get",
//     params,
//   });
// }

// /*根据计划id获取调整的生产站点列表*/
// export function stationget_list(params) {
//   return request({
//     url: "/icps/system/sign/basics/station/get_list",
//     method: "get",
//     params,
//   });
// }

// /*根据计划id获取调整的表格数据*/
// export function dataget_list(params) {
//   return request({
//     url: "/icps/system/sign/basics/data/get_list",
//     method: "get",
//     params,
//   });
// }
// /*调整生产站点：新增或修改*/
// export function stationsave_or_update(data) {
//   return request({
//     url: "/icps/system/sign/basics/station/save_or_update",
//     method: "post",
//     data,
//   });
// }
// /*调整时间：新增或修改*/
// export function timesave_or_update(data) {
//   return request({
//     url: "/icps/system/sign/basics/time/save_or_update",
//     method: "post",
//     data,
//   });
// }
// /*调整生产数据：新增或修改*/
// export function datasave_or_update(data) {
//   return request({
//     url: "/icps/system/sign/basics/data/save_or_update",
//     method: "post",
//     data,
//   });
// }

/*订单完成*/
export function updateOrderStatus(data) {
  return request({
    url: "/icps/system/sign/basics/plan/updateOrderStatus",
    method: "post",
    data,
  });
}
/*生产调整里面表格查询：就是子订单查询*/
export function plan_detail_and_child(params) {
  return request({
    url: "/icps/system/sign/basics/plan/plan_detail_and_child",
    method: "get",
    params,
  });
}
// 判断是否可修改泵送人员
export function planDetail(params) {
  return request({
    url: "/icps/system/sign/basics/plan/plan_detail",
    method: "get",
    params,
  });
}
// 获取自动签收配置
export function queryConfiguration(params) {
  return request({
    url: "/icps/system/sign/basics/plan/queryConfiguration",
    method: "get",
    params,
  });
}
// 设置自动签收
export function updateConfiguration(data) {
  return request({
    url: "/icps/system/sign/basics/plan/updateConfiguration",
    method: "post",
    data,
  });
}

// 根据往来业务-对应外协单位的工程名称数据
export function queryCooperationEngineering(params) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/queryCooperationEngineering",
    method: "get",
    params
  })
}
// 设置自动签收
export function updatePlanPumpTeam(data) {
  return request({
    url: "/icps/system/sign/basics/plan/updatePlanPumpTeam",
    method: "post",
    data,
  });
}

// 根据计划获取最优/最低成本站点
export function getProjectSiteCost(params) {
  return request({
    url: "/icps/system/sign/basics/plan/getProjectSiteCost",
    method: "get",
    params
  })
}
// 选择根据计划选择站点/外协
export function updatePlanStation(params) {
  return request({
    url: "/icps/system/sign/basics/plan/updatePlanStation",
    method: "post",
    params
  })
}
// 生产调整-取消订单
export function cancelPlan(data) {
  return request({
    url: "/icps/system/sign/basics/plan/cancelPlan",
    method: "post",
    data
  })
}
//  浇筑方式
export function getPouringMethodByType(params) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/getPouringMethodByType",
    method: "get",
    params
  })
}
// 站点 
export function selectStationByPlanId(data) {
  return request({
    url: "/icps/system/sign/basics/plan/selectStationByPlanId",
    method: "post",
    data
  })
}
/*根据浇筑方式获取泵送单位 */
export function pumpUnitByMethod(data) {
  return request({
    url: '/icps/system/sign/intelligent/projectPumpSet/queryAuto',
    method: 'post',
    data
  })
}